import ReactDOM from 'react-dom/client';
import App from '@/App.tsx';
import 'normalize.css';
import '@/styles/index.scss';
import '@/scripts/polify';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
